<template>
	<div class="main-content">
		<div class="header">
			<div class="container-fluid">
				<div class="card mt-5">
					<div class="card-body">
						<div class="row justify-content-between align-items-center">
							<div class="col-12 col-md-9 col-xl-7">
								<!-- Heading -->
								<h2 class="mb-2">Budget Plan</h2>

								<!-- Text -->
								<p class="text-muted mb-md-0">Manage you budget</p>
							</div>
							<div class="col-12 col-md-auto"></div>
						</div>
					</div>
				</div>
				<!-- Body -->
			</div>
		</div>
		<div class="container-fluid">
			<form @submit.prevent="submitAll">
				<div class="row">
					<div class="col-12">
						<div class="card">
							<div class="card-body">
								<div class="row">
									<div class="col-12">
										<div class="form-group">
											<label>Budget Title</label>
											<input
												name="budget_title"
												type="text"
												class="form-control"
												v-model="body.title"
												maxlength="100"
												v-validate="'required'"
											/>
											<span class="text-sm text-danger" v-show="errors.has('budget_title')"> Budget Title is Required </span>

											<!--                    <input v-model="form.name" name="name" v-validate="'required'" type="text" />
                    <span>{{ errors.first('name') }}</span>-->
											<!--                    <input
                        name="budget_title"
                        type="text"
                        class="form-control"
                        v-model="body.title"
                        maxlength="100"
                        v-validate="'max:100'"
                    />
                    <span class="text-sm text-danger" v-show="errors.has('budget_title')">
                      Budget Title must not exceed 100 characters
                    </span>-->
										</div>
									</div>
									<div class="col-6">
										<div class="form-group">
											<label>Department</label>
											<!-- {{ listFundCenter }}/ -->
											<v-select
												name="budget_department"
												v-validate="'required'"
												:options="listDepartement"
												v-model="body.fund_center_id"
												:reduce="(e) => e.value"
												placeholder="Select/Type Here..."
												class="w-md-auto"
												@input="selectFundCenter"
											/>
											<span class="text-sm text-danger" v-show="errors.has('budget_department')"> Department is Required </span>
											<!--                    <v-select
                      :options="listFundCenter.data" 
                      :clearable="false" v-model="body.fund_center_id" 
                      :reduce="(e) => e.id"
                      :get-option-label="option => option ? `${option.department_code} - ${option.department_name}` : ''"
                      @input="selectFundCenter($event)"
                      disabled
                      />-->
											<!-- :disabled="role_id !== 'Super Admin'" /> -->
										</div>
									</div>
									<div class="col-6">
										<div class="form-group">
											<label>Fund Center</label>
											<input type="text" class="form-control" disabled :value="body.fund_center" />
										</div>
									</div>
									<div class="col-6">
										<div class="form-group">
											<label>Year</label>
											<date-picker
												name="budget_year"
												v-validate="'required'"
												class="w-100"
												v-model="body.year"
												type="year"
												valueType="format"
											/>
											<span class="text-sm text-danger" v-show="errors.has('budget_year')"> Year is Required </span>
										</div>
									</div>
									<!-- <div class="col-4">
                  <div class="form-group">
                    <label>is Active</label>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault"
                        v-model="body.is_active">
                    </div>
                  </div>
                </div> -->
									<div class="col-6">
										<div class="form-group">
											<label>Total OPEX + CAPEX</label>
											<input type="text" class="form-control" disabled :value="convertNumber(body.sum_opex + body.sum_capex)" />
											<!--                    <p>Rp. {{ convertNumber(body.sum_opex+body.sum_capex) }}</p>-->
											<!-- <input type="text" class="form-control" disabled /> -->
										</div>
									</div>
								</div>
							</div>
							<div class="p-3 text-right">
								<button class="btn btn-outline-primary mr-2" type="button" @click="historyBack()">Cancel</button>
								<button class="btn btn-primary" type="button" @click="submitAll">Submit</button>
							</div>
						</div>
					</div>
				</div>

				<div class="card">
					<div class="card-body">
						<b-tabs id="tabs" v-model="activeTab" content-class="mt-3" pills fill>
							<b-tab id="tabOpex" :title="`OPEX (Total: Rp.${convertNumber(body.sum_opex)})`">
								<div class="row" v-if="loadingPaste">
									<div class="col-12">
										<div class="text-center">
											<b-spinner variant="primary" label="Spinning"></b-spinner>
										</div>
									</div>
								</div>
								<div class="row" v-else>
									<div class="col-12">
										<div class="card shadow-none border-secondary" style="border-style: dashed; background: none">
											<div class="card-body">
												<label class="w-100 text-center"
													>Paste from clipboard (spreadsheet)
													<span
														v-b-popover.hover.right="
															'Please ensure your spreadsheet locale is set to English (US) or English (UK) to display currency with comma separators for thousands, like this: 1,234,567.00.'
														"
														variant="secondary"
														style="cursor: pointer"
													>
														<i class="fe fe-help-circle text-danger" style="cursor: help"></i>
													</span>
												</label>
												<input
													type="text"
													class="form-control border-info"
													@paste="handlePasteOpex($event)"
													:disabled="!body.fund_center_id"
												/>
											</div>
										</div>
										<div
											class="card shadow-none border-secondary"
											@click.prevent="addBudget('opex')"
											style="border-style: dashed; background: none; cursor: pointer"
										>
											<div class="card-body">
												<div class="d-flex text-secondary w-100" style="align-items: center; justify-content: center">
													Add Transaction Type
												</div>
											</div>
										</div>
										<template>
											<div class="accordion" role="tablist">
												<!-- v-b-toggle="'collapse-a collapse-b'" -->
												<div class="card" v-if="body_create?.opex_error?.length > 0">
													<div class="card-header bg-danger text-white">
														<!-- v-b-toggle="`accor_opex_${i}`" -->
														<div class="d-flex w-100" style="align-items: center">
															<h3 class="m-0">
																<span> Opex error when generate excel </span>
																<br />
																<span class="small"> Transaction type, GL Code atau Fund tidak sesuai </span>
															</h3>
														</div>
													</div>
													<div class="card-body">
                            <div class="card" v-for="(item_opex_error, i) in body_create.opex_error" :key="`opex_error_${i}`">
                              <div class="card-body">
                                <div class="row">
                                  <div class="col-7 mt-2 mb-2 p-2 font-weight-bold">
                                    Transaction Type: <p>{{ item_opex_error.account_id }}</p>
                                  </div>
                                  <div class="col-5 mt-2 mb-2 p-2 font-weight-bold">
                                    Notes:
                                    <p v-for="(type, iii) in item_opex_error?.items.filter(b => !b.item)" :key="`opex_error_${iii}`">
                                      {{type?.notes}}
                                    </p>
                                  </div>
                                </div>

                                <table class="table table-bordered"  v-if="item_opex_error?.items">
                                  <thead>
                                  <tr>
                                    <th>Opex GL</th>
                                    <th>Budget Item</th>
                                    <th>Fund</th>
                                    <th style="width: 20%">Note</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="(budget, ii) in item_opex_error?.items.filter(b => b.item)" :key="`opex_error_${ii}`">
                                    <td>{{ budget?.item?.opex_gl_code }}</td>
                                    <td>{{ budget?.item?.budget_item }}</td>
                                    <td>{{ budget?.item?.fund }}</td>
                                    <td style="width: 20%">{{ budget?.item?.notes }}</td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
													</div>
												</div>
												<div class="card" v-for="(item, i) in body.opex" :key="`opex_${i}`">
													<div class="card-header">
														<!-- v-b-toggle="`accor_opex_${i}`" -->
														<div class="d-flex w-100" style="align-items: center">
															<h3 class="m-0">
																<span>Transaction Type #{{ i + 1 }} (Total: Rp. {{ convertNumber(item.sum) }})</span>
															</h3>
														</div>
														<!-- <div class=""> -->
														<button class="ml-auto btn btn-danger" type="button" @click="removeBudget('opex', i)">
															<i class="fe fe-trash"></i>
														</button>
														<!-- </div> -->
													</div>
													<!-- <b-collapse :id="`accor_opex_${i}`" :accordion="`opex_collapse`" role="tabpanel" visible> -->
													<div class="card-body">
														<div class="row">
															<div class="col-6">
																<div class="form-group">
																	<label>Transaction Type</label>
																	<v-select
																		:options="listTransactionType"
																		:reduce="(e) => e.id"
																		v-model="item.account_id"
																		:disabled="!body.fund_center_id"
																		label="account"
																		@input="selectTransaction($event, i)"
																		:name="`${i}_transaction_type_opex`"
																		v-validate="'required'"
																	/>
																	<span class="text-danger" v-show="isDuplicateErrorTransactionType(`${i}_transaction_type_opex`)">
																		Transaction Type is Duplicate
																	</span>
																	<span class="text-sm text-danger" v-show="errors.has(`${i}_transaction_type_opex`)">
																		Transaction Type is Required
																	</span>
																</div>
															</div>
														</div>
														<div class="row mb-3">
															<div class="col-12 text-right">
																<button class="btn btn-success" type="button" @click="newBudgetItem(i)">Add Budget Item</button>
															</div>
														</div>
														<div class="accordion" role="tablist">
															<!-- v-b-toggle="'collapse-a collapse-b'" -->
															<div class="card" v-for="(listBudget, index) in item.item" :key="`budget_item_${index}`">
																<div class="card-header">
																	<div class="d-flex w-100" v-b-toggle="`budget_item_toggle_${index}`" style="align-items: center">
																		<h3 class="m-0">
																			<span>Budget Item #{{ index + 1 }} </span>
																		</h3>
																	</div>
																	<button class="btn btn-danger" type="button" @click="removeBudgetItem(i, index)">
																		<i class="fe fe-trash"></i>
																	</button>
																</div>
																<!-- <b-collapse :id="`budget_item_toggle_${index}`" :accordion="`budget_item_collapse`" -->
																<!-- role="tabpanel"> -->
																<div class="row p-3">
																	<div class="col-4">
																		<div class="form-group">
																			<label>TT Budget Item</label>
																			<v-select
																				:options="item.listBudget"
																				:reduce="(e) => e.id"
																				label="budget_item"
																				:value="listBudget.budget_item_id"
																				@input="searchGL($event, i, index)"
																				:name="`${i}_${index}_budget_item_opex`"
																				v-validate="'required'"
																				data-vv-validate-on="change"
																			/>
																			<span class="text-danger" v-show="isDuplicateErrorBudgetItemOpex(`${i}_${index}_budget_item_opex`)">
																				TT Budget Item is Duplicate
																			</span>
																			<span class="text-sm text-danger" v-show="errors.has(`${i}_${index}_budget_item_opex`)">
																				TT Budget Item is Required
																			</span>
																		</div>
																	</div>
																	<div class="col-4">
																		<div class="form-group">
																			<label>GL Number</label>
																			<!-- {{ listFundCenter }}/ -->
																			<input type="text" class="form-control" v-model="listBudget.opex_gl_code" disabled />
																		</div>
																	</div>
																	<div class="col-4">
																		<div class="form-group">
																			<label>Fund</label>
																			<input type="hidden" class="form-control" v-model="listBudget.fund_id" disabled />
																			<input type="text" class="form-control" v-model="listBudget.fund.fund" disabled />
																		</div>
																	</div>
																</div>
																<div class="col-12 mt-3">
																	<div class="d-flex justify-content-between mb-2">
																		<input
																			type="text"
																			class="form-control w-50 border-info"
																			placeholder="Paste from clipboard"
																			:disabled="!listBudget.budget_item_id"
																			@paste="handlePasteTaskOpex($event, i, index)"
																		/>
																		<button class="btn btn-sm btn-success mb-3" type="button" @click="newBudgetTask(i, index)">
																			Add Budget Task
																		</button>
																	</div>
																	<div style="overflow: auto">
																		<table class="table table-bordered" style="table-layout: fixed; word-wrap: break-word">
																			<thead>
																				<tr>
																					<th style="width: 100px">Action</th>
																					<th style="width: 300px">Budget Task</th>
																					<th style="width: 300px">Description</th>

																					<th style="width: 200px">Jan</th>
																					<th style="width: 200px">Feb</th>
																					<th style="width: 200px">Mar</th>
																					<th style="width: 200px">Apr</th>
																					<th style="width: 200px">May</th>
																					<th style="width: 200px">Jun</th>
																					<th style="width: 200px">Jul</th>
																					<th style="width: 200px">Aug</th>
																					<th style="width: 200px">Sep</th>
																					<th style="width: 200px">Oct</th>
																					<th style="width: 200px">Nov</th>
																					<th style="width: 200px">Dec</th>
																					<th style="width: 200px">Total</th>
																				</tr>
																			</thead>
																			<tbody v-for="(item, indexBudget) in listBudget.budget" :key="`indexBudget_${indexBudget}`">
																				<tr>
																					<td class="text-center">
																						<i
																							class="fe fe-x-circle text-danger"
																							style="cursor: pointer"
																							@click="removeBudgetTaskOpex(i, index, indexBudget)"
																						></i>
																					</td>
																					<td>
																						<!--                                          <input type="text" :class="`form-control ${errors.has(`${indexBudget}_budget_task`) ? 'is-invalid' : ''  || isDuplicateError(indexBudget) ? 'is-invalid' : ''}`"
                                            v-model="item.name" :name="`${indexBudget}_budget_task`" v-validate="'required'"
                                            @blur="validateDuplicate(indexBudget)" />
                                            <span
                                             class="invalid-feedback"
                                             v-show="errors.has(`${indexBudget}_budget_task`)"
                                            >
                                              Budget Task is Required
                                            </span>
                                            <span class="invalid-feedback" v-show="isDuplicateError(indexBudget)">
                                              Budget Task is Duplicate
                                            </span>-->
																						<input
																							type="text"
																							:class="`form-control ${
																								errors.has(`${i}_${index}_${indexBudget}_budget_task_opex`) ? 'is-invalid' : ''
																							}`"
																							v-model="item.name"
																							:name="`${i}_${index}_${indexBudget}_budget_task_opex`"
																							v-validate="'required'"
																							@input="validateDuplicateTaskOpex(i, index)"
																						/>
																						<span
																							class="invalid-feedback"
																							v-show="errors.has(`${i}_${index}_${indexBudget}_budget_task_opex`)"
																						>
																							Budget Task is Required
																						</span>
																						<span
																							class="text-danger"
																							v-show="isDuplicateErrorOpex(`${i}_${index}_${indexBudget}_budget_task_opex`)"
																						>
																							Budget Task is Duplicate
																						</span>
																					</td>
																					<td>
																						<input type="text" class="form-control" v-model="item.description" />
																					</td>
																					<td>
																						<!--                                          <vue-numeric class="form-control" style="border: none;" currency="Rp. "
                                            separator="," v-model="item.jan" @focus="handleFocus"
                                            @blur="countSum(item, i, index, indexBudget)" />-->
																						<vue-numeric
																							class="form-control"
																							style="border: none"
																							currency="Rp. "
																							separator=","
																							v-model="item.jan"
																							@blur="countSum(item, i, index, indexBudget)"
																						/>
																					</td>
																					<td>
																						<vue-numeric
																							class="form-control"
																							style="border: none"
																							currency="Rp. "
																							separator=","
																							v-model="item.feb"
																							@blur="countSum(item, i, index, indexBudget)"
																						/>
																					</td>
																					<td>
																						<vue-numeric
																							class="form-control"
																							style="border: none"
																							currency="Rp. "
																							separator=","
																							v-model="item.mar"
																							@blur="countSum(item, i, index, indexBudget)"
																						/>
																					</td>
																					<td>
																						<vue-numeric
																							class="form-control"
																							style="border: none"
																							currency="Rp. "
																							separator=","
																							v-model="item.apr"
																							@blur="countSum(item, i, index, indexBudget)"
																						/>
																					</td>
																					<td>
																						<vue-numeric
																							class="form-control"
																							style="border: none"
																							currency="Rp. "
																							separator=","
																							v-model="item.may"
																							@blur="countSum(item, i, index, indexBudget)"
																						/>
																					</td>
																					<td>
																						<vue-numeric
																							class="form-control"
																							style="border: none"
																							currency="Rp. "
																							separator=","
																							v-model="item.jun"
																							@blur="countSum(item, i, index, indexBudget)"
																						/>
																					</td>
																					<td>
																						<vue-numeric
																							class="form-control"
																							style="border: none"
																							currency="Rp. "
																							separator=","
																							v-model="item.jul"
																							@blur="countSum(item, i, index, indexBudget)"
																						/>
																					</td>
																					<td>
																						<vue-numeric
																							class="form-control"
																							style="border: none"
																							currency="Rp. "
																							separator=","
																							v-model="item.aug"
																							@blur="countSum(item, i, index, indexBudget)"
																						/>
																					</td>
																					<td>
																						<vue-numeric
																							class="form-control"
																							style="border: none"
																							currency="Rp. "
																							separator=","
																							v-model="item.sep"
																							@blur="countSum(item, i, index, indexBudget)"
																						/>
																					</td>
																					<td>
																						<vue-numeric
																							class="form-control"
																							style="border: none"
																							currency="Rp. "
																							separator=","
																							v-model="item.oct"
																							@blur="countSum(item, i, index, indexBudget)"
																						/>
																					</td>
																					<td>
																						<vue-numeric
																							class="form-control"
																							style="border: none"
																							currency="Rp. "
																							separator=","
																							v-model="item.nov"
																							@blur="countSum(item, i, index, indexBudget)"
																						/>
																					</td>
																					<td>
																						<vue-numeric
																							class="form-control"
																							style="border: none"
																							currency="Rp. "
																							separator=","
																							v-model="item.dec"
																							@blur="countSum(item, i, index, indexBudget)"
																						/>
																					</td>
																					<td :contenteditable="false">Rp. {{ convertNumber(item.total) }}</td>
																				</tr>
																			</tbody>
																			<tbody>
																				<tr>
																					<td colspan="3" class="text-right">Total :</td>
																					<td>Rp. {{ convertNumber(listBudget.sum.jan) }}</td>
																					<td>Rp. {{ convertNumber(listBudget.sum.feb) }}</td>
																					<td>Rp. {{ convertNumber(listBudget.sum.mar) }}</td>
																					<td>Rp. {{ convertNumber(listBudget.sum.apr) }}</td>
																					<td>Rp. {{ convertNumber(listBudget.sum.may) }}</td>
																					<td>Rp. {{ convertNumber(listBudget.sum.jun) }}</td>
																					<td>Rp. {{ convertNumber(listBudget.sum.jul) }}</td>
																					<td>Rp. {{ convertNumber(listBudget.sum.aug) }}</td>
																					<td>Rp. {{ convertNumber(listBudget.sum.sep) }}</td>
																					<td>Rp. {{ convertNumber(listBudget.sum.oct) }}</td>
																					<td>Rp. {{ convertNumber(listBudget.sum.nov) }}</td>
																					<td>Rp. {{ convertNumber(listBudget.sum.dec) }}</td>
																					<td>Rp. {{ convertNumber(listBudget.sum.total) }}</td>
																				</tr>
																			</tbody>
																		</table>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<!-- </b-collapse> -->
												</div>
											</div>
										</template>
									</div>
								</div>
							</b-tab>
							<b-tab id="tabCapex" :title="`CAPEX (Total: Rp. ${convertNumber(body.sum_capex)})`">
								<div class="row" v-if="loadingPaste">
									<div class="col-12">
										<div class="text-center">
											<b-spinner variant="primary" label="Spinning"></b-spinner>
										</div>
									</div>
								</div>
								<div class="row" v-else>
									<div class="col-12">
										<div class="card shadow-none border-secondary" style="border-style: dashed; background: none">
											<div class="card-body">
												<label class="w-100 text-center"
													>Paste from clipboard (spreadsheet)
													<span
														v-b-popover.hover.right="
															'Please ensure your spreadsheet locale is set to English (US) or English (UK) to display currency with comma separators for thousands, like this: 1,234,567.00.'
														"
														variant="secondary"
														style="cursor: pointer"
													>
														<i class="fe fe-help-circle text-danger" style="cursor: help"></i>
													</span>
												</label>
												<input
													type="text"
													class="form-control border-info"
													@paste="handlePasteCapex($event)"
													:disabled="!body.fund_center_id"
												/>
											</div>
										</div>
										<div
											class="card shadow-none border-secondary"
											@click.prevent="addBudget('capex')"
											style="border-style: dashed; background: none; cursor: pointer"
										>
											<div class="card-body">
												<div class="d-flex text-secondary w-100" style="align-items: center; justify-content: center">
													Add Budget Item
												</div>
											</div>
										</div>
										<template>
											<div class="accordion" role="tablist">
												<!-- v-b-toggle="'collapse-a collapse-b'" -->
												<!--                      <div class="card" v-for="(listBudget, index) in item.item" :key="`budget_item_${index}`">-->

												<div class="card" v-if="body_create?.capex_error?.length > 0">
													<div class="card-header bg-danger text-white">
														<!-- v-b-toggle="`accor_opex_${i}`" -->
														<div class="d-flex w-100" style="align-items: center">
															<h3 class="m-0">
																<span>Capex error when generate excel</span>
																<br />
																<span class="small"> GL Code atau Fund tidak sesuai </span>
															</h3>
														</div>
													</div>
                          <div class="card-body">

                            <table class="table table-bordered" >
                              <thead>
                              <tr>
                                <th>Opex GL</th>
                                <th>Budget Item</th>
                                <th>Fund</th>
                                <th style="width: 20%">Note</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="(budget, ii) in body_create?.capex_error" :key="`capex_error_${ii}`">
                                <td>{{ budget?.capex_gl_code }}</td>
                                <td>{{ budget?.budget_item }}</td>
                                <td>{{ budget?.fund }}</td>
                                <td style="width: 20%">{{ budget?.notes }}</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
<!--													<div class="card-body">
														<table class="table table-bordered">
															<thead>
																<td class="col-2 align-middle pt-2 pb-0">GL Code</td>
																<td class="col-2 align-middle pt-2 pb-0">Fund</td>
																<td class="col-3 align-middle pt-2 pb-0">Name</td>
																<td class="col-5 align-middle pt-2 pb-0">Description</td>
															</thead>
														</table>
														<div v-for="(item_capex_error, i) in body_create.capex_error" :key="`opex_error_${i}`">
															<table class="table table-bordered">
																<tbody v-for="(budget, i) in item_capex_error.budget" :key="`capex_error_budget_${i}`">
																	<td class="col-2">{{ item_capex_error.capex_gl_code }}</td>
																	<td class="col-2">{{ item_capex_error.fund.fund }}</td>
																	<td class="col-3">{{ budget.name }}</td>
																	<td class="col-5">{{ budget.description }}</td>
																</tbody>
															</table>
														</div>
													</div>-->
												</div>

												<div class="card" v-for="(item, i) in body.capex" :key="`capex_${i}`">
													<div class="card-header" v-b-toggle="`accor_capex_${i}`">
														<div class="d-flex w-100" style="align-items: center">
															<h3 class="m-0">
																<span> Budget Item #{{ i + 1 }} (Total: Rp. {{ convertNumber(item.sum.total) }})</span>
															</h3>
															<div class="ml-auto">
																<button class="btn btn-danger" type="button" @click="removeBudget('capex', i)">
																	<i class="fe fe-trash"></i>
																</button>
															</div>
														</div>
													</div>
													<!-- <b-collapse :id="`accor_capex_${i}`" :accordion="`capex_collapse`" role="tabpanel"> -->
													<div class="row p-3">
														<div class="col-4">
															<div class="form-group">
																<label>TT Budget Item</label>
																<v-select
																	:options="listCapex"
																	:reduce="(e) => e.id"
																	label="budget_item"
																	:value="body.capex[i].capex_gl_id"
																	@input="searchGLCapex($event, i)"
																	:name="`${i}_budget_item_capex`"
																	v-validate="'required'"
																	data-vv-validate-on="change"
																	:filterBy="
																		(option, label, search) =>
																			option.budget_item.toLowerCase().includes(search.toLowerCase()) ||
																			option.fund.toLowerCase().includes(search.toLowerCase())
																	"
																>
																	<template slot="option" slot-scope="option">
																		{{ `${option?.fund} - ${option?.budget_item}` }}
																	</template>
																	<template slot="selected-option" slot-scope="option">
																		{{ `${option?.fund} - ${option?.budget_item}` }}
																	</template>
																</v-select>
																<span class="text-danger" v-show="isDuplicateErrorBudgetItemCapex(`${i}_budget_item_capex`)">
																	TT Budget Item is Duplicate
																</span>
																<span class="text-sm text-danger" v-show="errors.has(`${i}_budget_item_capex`)">
																	TT Budget Item is Required
																</span>
															</div>
														</div>
														<div class="col-4">
															<div class="form-group">
																<label>GL Number</label>
																<input type="text" class="form-control" v-model="item.capex_gl_code" disabled />
															</div>
														</div>
														<div class="col-4">
															<div class="form-group">
																<label>Fund</label>
																<input type="hidden" class="form-control" v-model="item.fund_id" disabled />
																<input type="text" class="form-control" v-model="item.fund.fund" disabled />
															</div>
														</div>
													</div>
													<div class="row">
														<div class="col-12 mt-3 p-5">
															<div class="d-flex justify-content-between mb-2">
																<input
																	type="text"
																	class="form-control w-50 border-info"
																	placeholder="Paste from clipboard"
																	:disabled="!body.capex[i].account_id"
																	@paste="handlePasteTaskCapex($event, i)"
																/>
																<button class="btn btn-sm btn-success mb-3" type="button" @click="newBudgetTaskCapex(i)">
																	Add Budget Task
																</button>
															</div>
															<div style="overflow: auto">
																<table class="table table-bordered" style="table-layout: fixed; word-wrap: break-word">
																	<thead>
																		<tr>
																			<th style="width: 100px">Action</th>
																			<th style="width: 300px">Budget Task</th>
																			<th style="width: 300px">Description</th>

																			<th style="width: 220px">Jan</th>
																			<th style="width: 220px">Feb</th>
																			<th style="width: 220px">Mar</th>
																			<th style="width: 220px">Apr</th>
																			<th style="width: 220px">May</th>
																			<th style="width: 220px">Jun</th>
																			<th style="width: 220px">Jul</th>
																			<th style="width: 220px">Aug</th>
																			<th style="width: 220px">Sep</th>
																			<th style="width: 220px">Oct</th>
																			<th style="width: 220px">Nov</th>
																			<th style="width: 220px">Dec</th>
																			<th style="width: 220px">Total</th>
																		</tr>
																	</thead>
																	<tbody v-for="(item, indexBudget) in item.budget" :key="`indexBudget_${indexBudget}`">
																		<tr>
																			<td class="text-center">
																				<i
																					class="fe fe-x-circle text-danger"
																					style="cursor: pointer"
																					@click="removeBudgetTaskCapex(i, indexBudget)"
																				></i>
																			</td>
																			<td>
																				<!--                                        <input type="text" class="form-control" style="border: none"
                                          v-model="item.name" />-->

																				<input
																					type="text"
																					:class="`form-control ${errors.has(`${i}_${indexBudget}_budget_task_capex`) ? 'is-invalid' : ''}`"
																					v-model="item.name"
																					:name="`${i}_${indexBudget}_budget_task_capex`"
																					v-validate="'required'"
																					@input="validateDuplicateCapex(i)"
																				/>
																				<span class="invalid-feedback" v-show="errors.has(`${i}_${indexBudget}_budget_task_capex`)">
																					Budget Task is Required
																				</span>
																				<span class="text-danger" v-show="isDuplicateErrorCapex(`${i}_${indexBudget}_budget_task_capex`)">
																					Budget Task is Duplicate
																				</span>
																			</td>
																			<td>
																				<input type="text" class="form-control" style="border: none" v-model="item.description" />
																			</td>
																			<td>
																				<vue-numeric
																					class="form-control"
																					style="border: none"
																					currency="Rp. "
																					separator=","
																					v-model="item.jan"
																					@blur="countSumCapex(item, i, indexBudget)"
																				/>
																			</td>
																			<td>
																				<vue-numeric
																					class="form-control"
																					style="border: none"
																					currency="Rp. "
																					separator=","
																					v-model="item.feb"
																					@blur="countSumCapex(item, i, indexBudget)"
																				/>
																			</td>
																			<td>
																				<vue-numeric
																					class="form-control"
																					style="border: none"
																					currency="Rp. "
																					separator=","
																					v-model="item.mar"
																					@blur="countSumCapex(item, i, indexBudget)"
																				/>
																			</td>
																			<td>
																				<vue-numeric
																					class="form-control"
																					style="border: none"
																					currency="Rp. "
																					separator=","
																					v-model="item.apr"
																					@blur="countSumCapex(item, i, indexBudget)"
																				/>
																			</td>
																			<td>
																				<vue-numeric
																					class="form-control"
																					style="border: none"
																					currency="Rp. "
																					separator=","
																					v-model="item.may"
																					@blur="countSumCapex(item, i, indexBudget)"
																				/>
																			</td>
																			<td>
																				<vue-numeric
																					class="form-control"
																					style="border: none"
																					currency="Rp. "
																					separator=","
																					v-model="item.jun"
																					@blur="countSumCapex(item, i, indexBudget)"
																				/>
																			</td>
																			<td>
																				<vue-numeric
																					class="form-control"
																					style="border: none"
																					currency="Rp. "
																					separator=","
																					v-model="item.jul"
																					@blur="countSumCapex(item, i, indexBudget)"
																				/>
																			</td>
																			<td>
																				<vue-numeric
																					class="form-control"
																					style="border: none"
																					currency="Rp. "
																					separator=","
																					v-model="item.aug"
																					@blur="countSumCapex(item, i, indexBudget)"
																				/>
																			</td>
																			<td>
																				<vue-numeric
																					class="form-control"
																					style="border: none"
																					currency="Rp. "
																					separator=","
																					v-model="item.sep"
																					@blur="countSumCapex(item, i, indexBudget)"
																				/>
																			</td>
																			<td>
																				<vue-numeric
																					class="form-control"
																					style="border: none"
																					currency="Rp. "
																					separator=","
																					v-model="item.oct"
																					@blur="countSumCapex(item, i, indexBudget)"
																				/>
																			</td>
																			<td>
																				<vue-numeric
																					class="form-control"
																					style="border: none"
																					currency="Rp. "
																					separator=","
																					v-model="item.nov"
																					@blur="countSumCapex(item, i, indexBudget)"
																				/>
																			</td>
																			<td>
																				<vue-numeric
																					class="form-control"
																					style="border: none"
																					currency="Rp. "
																					separator=","
																					v-model="item.dec"
																					@blur="countSumCapex(item, i, indexBudget)"
																				/>
																			</td>
																			<td :contenteditable="false">
																				{{ convertNumber(item.total) }}
																			</td>
																		</tr>
																	</tbody>
																	<tbody>
																		<tr>
																			<td colspan="3" class="text-right">Total :</td>
																			<td>Rp. {{ convertNumber(item.sum.jan) }}</td>
																			<td>Rp. {{ convertNumber(item.sum.feb) }}</td>
																			<td>Rp. {{ convertNumber(item.sum.mar) }}</td>
																			<td>Rp. {{ convertNumber(item.sum.apr) }}</td>
																			<td>Rp. {{ convertNumber(item.sum.may) }}</td>
																			<td>Rp. {{ convertNumber(item.sum.jun) }}</td>
																			<td>Rp. {{ convertNumber(item.sum.jul) }}</td>
																			<td>Rp. {{ convertNumber(item.sum.aug) }}</td>
																			<td>Rp. {{ convertNumber(item.sum.sep) }}</td>
																			<td>Rp. {{ convertNumber(item.sum.oct) }}</td>
																			<td>Rp. {{ convertNumber(item.sum.nov) }}</td>
																			<td>Rp. {{ convertNumber(item.sum.dec) }}</td>
																			<td>Rp. {{ convertNumber(item.sum.total) }}</td>
																		</tr>
																	</tbody>
																</table>
															</div>
														</div>
													</div>
													<!-- </b-collapse> -->
												</div>
											</div>
										</template>
									</div>
								</div>
							</b-tab>
						</b-tabs>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axiosIns from '@/api/axios';
import Vue from 'vue';
import Datepicker from 'vuejs-datepicker';
import TreePlan from '../../components/helpers/treePlan.vue';
import DebouncedCurrencyInput from './DebouncedCurrencyInput.vue';
export default {
	components: {
		TreePlan,
		DebouncedCurrencyInput,
		Datepicker,
	},
	computed: {
		listFundCenter() {
			return this.$store.getters['fundCenter/listData'];
		},
		listTT() {
			return this.$store.getters['ttAccount/listAccount'];
		},
		/*listFund() {
        return this.$store.getters["fund/listData"];
      },*/
		/*listCapex() {
        return this.$store.getters["capexGL/listData"];
      },*/
		activePlan() {
			return this.$store.getters['budgetPlan/activePlan'];
		},
		body_create() {
			return this.$store.getters['budgetPlan/body_create'];
		},
	},
	data() {
		return {
			activeTab: 0,
			listTransactionType: [],
			role_id: '',
			body: {
				title: '',
				year: '',
				is_active: false,
				fund_center: '',
				fund_center_id: '',
				opex: [],
				capex: [],
				sum_capex: 0,
				sum_opex: 0,
			},
			value: '',
			values: '',
			valuess: '',
			fund_center: '',
			// body.opex: [],
			budget_capex: [],
			inputType: 'text',
			optionCurrency: {
				currency: 'EUR',
				currencyDisplay: 'hidden',
				hideCurrencySymbolOnFocus: false,
				hideGroupingSeparatorOnFocus: false,
				hideNegligibleDecimalDigitsOnFocus: false,
			},
			duplicateErrorIndexes: [], // opex task
			duplicateErrorIndexesCapex: [], // capex task
			duplicateErrorIndexesTransactionType: [], // opex transaction
			duplicateErrorIndexesBudgetItemOpex: [], // opex item
			duplicateErrorIndexesBudgetItemCapex: [], // capex item
			listDepartement: [],
			listFund: [],
			listFundCapex: [],
			listCapex: [],
			capexId: [],
			loadingPaste: false,
			isLoading: false,
		};
	},
	watch: {
		fund_center: function (newValue) {
			const result = newValue.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			Vue.nextTick(() => (this.body.fund_center = result));
		},
	},
	async mounted() {
		await this.getListDepartment();
		//this.getFundCenter();
		await this.getListTT();
		//this.getListFund();
		/*this.getListCapexGL();*/
		//this.selectFundCenter();
		this.role_id = localStorage.getItem('roles');
		await this.setSelectedDepartment();
		this.listTransactionType = this.listTT.data;
		this.listTransactionType = this.listTransactionType.filter((item) => item.type === 'Opex');
		if (
			this.body_create?.title &&
			this.body_create.year &&
			(this.body_create?.opex?.length > 0 ||
				this.body_create?.capex?.length > 0 ||
				this.body_create?.opex_error?.length > 0 ||
				this.body_create?.capex_error?.length > 0)
		) {
			this.body = this.body_create;
			this.handlePasteOpexImport();
			//this.handlePasteTaskOpexImport()
			//this.handlePasteCapex()
			//this.handlePasteTaskCapex()
		}
	},
	methods: {
		async getListDepartment() {
			try {
				const response = await axiosIns.get('/fund-center/list-department');
				this.listDepartement = response.data.data.map((items) => ({
					label: items.department_code + ' - ' + items.organization,
					value: items.id,
					row: items,
				}));
			} catch (error) {
				console.error('Failed to fetch year options:', error);
			}
		},
		// Fungsi untuk mengecek apakah ada duplikat opex
		validateDuplicateTaskOpex(index, itemIndex) {
			const seen = [];
			const duplicateIndexes = [];
			const listBudget = this.body.opex[index]?.item[itemIndex]?.budget || [];
			this.duplicateErrorIndexes = this.duplicateErrorIndexes.filter((item) => !item.startsWith(`${index}_${itemIndex}_`));

			for (let x = 0; x < listBudget.length; x++) {
				const trimmed = listBudget[x].name?.trim().toLowerCase();
				//push to seen only if not empty
				if (trimmed) {
					//push both duplicate indexes
					if (seen.includes(trimmed)) {
						duplicateIndexes.push(seen.indexOf(trimmed));
						duplicateIndexes.push(x);
					}
					seen.push(trimmed);
				}
			}

			for (let duplicate of duplicateIndexes) {
				this.duplicateErrorIndexes.push(`${index}_${itemIndex}_${duplicate}_budget_task_opex`);
			}
		},
		validateDuplicateTransactionType(index) {
			const seen = [];
			const duplicateIndexes = [];
			const listTransactionType = this.body.opex || [];
			//clear entries for this index
			this.duplicateErrorIndexesTransactionType = [];

			for (let x = 0; x < listTransactionType.length; x++) {
				const trimmed = listTransactionType[x].account_id?.trim().toLowerCase();
				//push to seen only if not empty
				if (trimmed) {
					//push both duplicate indexes
					if (seen.includes(trimmed)) {
						duplicateIndexes.push(seen.indexOf(trimmed));
						duplicateIndexes.push(x);
					}
					seen.push(trimmed);
				}
			}

			for (let duplicate of duplicateIndexes) {
				this.duplicateErrorIndexesTransactionType.push(`${duplicate}_transaction_type_opex`);
			}
		},
		validateDuplicateBudgetItemOpex(index) {
			const seen = [];
			const duplicateIndexes = [];
			const items = this.body.opex[index]?.item || [];
			//clear entries for this index
			this.duplicateErrorIndexesBudgetItemOpex = this.duplicateErrorIndexesBudgetItemOpex.filter(
				(item) => !item.startsWith(`${index}_`)
			);
			//
			for (let x = 0; x < items.length; x++) {
				const trimmed = items[x].budget_item_id?.trim().toLowerCase();
				//push to seen only if not empty
				if (trimmed) {
					//push both duplicate indexes
					if (seen.includes(trimmed)) {
						duplicateIndexes.push(seen.indexOf(trimmed));
						duplicateIndexes.push(x);
					}
					seen.push(trimmed);
				}
			}

			for (let duplicate of duplicateIndexes) {
				this.duplicateErrorIndexesBudgetItemOpex.push(`${index}_${duplicate}_budget_item_opex`);
			}
		},
		// Fungsi untuk mengecek apakah ada duplikat capex
		validateDuplicateCapex(index) {
			const seen = [];
			const duplicateIndexes = [];
			const listBudget = this.body.capex[index]?.budget || [];
			//clear entries for this index
			this.duplicateErrorIndexesCapex = this.duplicateErrorIndexesCapex.filter((item) => !item.startsWith(`${index}_`));

			for (let x = 0; x < listBudget.length; x++) {
				const trimmed = listBudget[x].name?.trim().toLowerCase();
				//push to seen only if not empty
				if (trimmed) {
					//push both duplicate indexes
					if (seen.includes(trimmed)) {
						duplicateIndexes.push(seen.indexOf(trimmed));
						duplicateIndexes.push(x);
					}
					seen.push(trimmed);
				}
			}

			for (let duplicate of duplicateIndexes) {
				this.duplicateErrorIndexesCapex.push(`${index}_${duplicate}_budget_task_capex`);
			}
		},
		validateDuplicateBudgetItemCapex(index) {
			const seen = [];
			const duplicateIndexes = [];
			const listTransactionType = this.body.capex || [];
			//clear entries for this index
			this.duplicateErrorIndexesBudgetItemCapex = [];

			for (let x = 0; x < listTransactionType.length; x++) {
				const trimmed = listTransactionType[x].capex_gl_id?.trim().toLowerCase();
				//push to seen only if not empty
				if (trimmed) {
					//push both duplicate indexes
					if (seen.includes(trimmed)) {
						duplicateIndexes.push(seen.indexOf(trimmed));
						duplicateIndexes.push(x);
					}
					seen.push(trimmed);
				}
			}

			for (let duplicate of duplicateIndexes) {
				this.duplicateErrorIndexesBudgetItemCapex.push(`${duplicate}_budget_item_capex`);
			}
		},

		// Fungsi untuk mengecek apakah ada error duplikat untuk index tertentu
		/*isDuplicateError(indexBudget) {
        return this.duplicateErrorIndexes.includes(indexBudget);
      },*/
		isDuplicateErrorBudgetItemOpex(index) {
			return this.duplicateErrorIndexesBudgetItemOpex.includes(index);
		},
		isDuplicateErrorBudgetItemCapex(index) {
			return this.duplicateErrorIndexesBudgetItemCapex.includes(index);
		},
		isDuplicateErrorTransactionType(index) {
			return this.duplicateErrorIndexesTransactionType.includes(index);
		},
		isDuplicateErrorOpex(index) {
			return this.duplicateErrorIndexes.includes(index);
		},
		isDuplicateErrorCapex(index) {
			return this.duplicateErrorIndexesCapex.includes(index);
		},
		truncate(e, field, max, obj) {
			const fullValue = e.target.value;

			this[obj][field] = fullValue;

			if (fullValue.length > max) {
				e.target.value = fullValue.toString().substring(0, max);
			}
		},
		getFundCenter() {
			this.$store.dispatch('fundCenter/GET_LIST_DATA', {
				pageNumber: 1,
				pageSize: 1000,
			});
		},
		async getListTT() {
			await this.$store.dispatch('ttAccount/GET_LIST_ACCOUNT', {
				pageNumber: 1,
				pageSize: 1000,
			});
		},
		async getListFund(budget_item_id, iOpex, iItem) {
			const response = await axiosIns.get(`/fund/list/${this.body.fund_center_id}/${budget_item_id}`);
			if (response.data.data.length > 0) {
				this.listFund[iOpex] = response.data.data.map((items) => ({
					label: items.fund.fund,
					value: items.fund.id,
					gl_code: items.gl_code,
				}));
				this.body.opex[iOpex].item[iItem].fund_id = response.data.data[0].fund.id;
				this.body.opex[iOpex].item[iItem].opex_gl_code = response.data.data[0].gl_code;
				this.body.opex[iOpex].item[iItem].fund.fund = response.data.data[0].fund.fund;
			} else {
				this.body.opex[iOpex].item[iItem].fund_id = '';
				this.body.opex[iOpex].item[iItem].opex_gl_code = '';
				this.body.opex[iOpex].item[iItem].fund.fund = '';
			}
		},
		async getListFundCapex(budget_item_id) {
			this.listFundCapex = [];
			const response = await axiosIns.get(`/fund/list/${this.body.fund_center_id}/${budget_item_id}`);
			if (response.data.data.length > 0) {
				this.listFundCapex = response.data.data.map((items) => ({
					label: items.fund.fund,
					value: items.fund.id,
					gl_code: items.gl_code,
				}));
			}
		},
		/*getListCapexGL() {
        this.$store.dispatch("capexGL/GET_LIST_DATA", {
          pageNumber: 1,
          pageSize: 1000
        });
      },*/

		makeFolder: function (item) {
			Vue.set(item, 'children', []);
			this.addItem(item);
		},
		addItem: function (item) {
			item.children.push({
				name: 'new stuff',
			});
		},
		addBudget(type) {
			if (type === 'opex') {
				this.body.opex.push({
					account_id: '',
					listBudget: [],
					item: [],
					sum: 0,
				});
			} else if (type === 'capex') {
				this.body.capex.push({
					account_id: '',
					capex_gl_id: '',
					capex_gl_code: '',
					fund_id: '',
					fund: [],
					budget: [],
					sum: {
						jan: 0,
						feb: 0,
						mar: 0,
						apr: 0,
						may: 0,
						jun: 0,
						jul: 0,
						aug: 0,
						sep: 0,
						oct: 0,
						nov: 0,
						dec: 0,
						total: 0,
					},
				});
			}
		},
		async removeBudget(type, index) {
			const confirmed = await this.deleteConfirmation();
			if (!confirmed) {
				return;
			}
			if (type === 'opex') {
				this.body.opex.splice(index, 1);
				this.validateDuplicateTransactionType(index);
			} else if (type === 'capex') {
				this.body.capex.splice(index, 1);
				this.validateDuplicateBudgetItemCapex(index);
			}
			this.countSumSummary();
		},
		async removeBudgetItem(i, index) {
			const confirmed = await this.deleteConfirmation();
			if (!confirmed) {
				return;
			}
			this.body.opex[i].item.splice(index, 1);
			this.countSumSummary();
			this.validateDuplicateBudgetItemOpex(i);
		},

		async selectFundCenter(value) {
			this.listCapex = [];
			this.listFundCapex = [];
			for (let i = 0; i < this.body.capex.length; i++) {
				this.body.capex[i].account_id = '';
				this.body.capex[i].capex_gl_code = '';
				this.body.capex[i].fund = [];
			}

			if (value === null) {
				this.body.fund_center_id = null;
				this.body.fund_center = null;
			} else {
				let id = this.body.fund_center_id ? this.body.fund_center_id : null;
				if (id) {
					await axiosIns.get(`${axiosIns.defaults.baseURL}/fund-center/${id}`).then((resp) => {
						this.body.fund_center = resp.data.data.fund_center;
					});

					const resp = await axiosIns.get(`${axiosIns.defaults.baseURL}/account/budget-items/${this.body.fund_center_id}`);
					const uniqueData = Object.values(
						resp.data.data.reduce((acc, item) => {
							if (!acc[`${item.account.account}-${item.fund.fund}`]) {
								acc[`${item.account.account}-${item.fund.fund}`] = item; // keep first occurrence
							}
							return acc;
						}, {})
					);
					this.listCapex = uniqueData.map((items) => ({
						id: items.id,
						account_code: items.account.code,
						fund: items.fund.fund,
						budget_item: items.account.account,
						gl_code: items.gl_code,
						account_id: items.account_id,
						fund_id: items.fund_id,
					}));
				}
			}
		},
		async selectTransaction(evt, i) {
			if (!evt) {
				const confirmed = await this.deleteConfirmation();
				if (!confirmed) {
					return;
				}
			}
			this.body.opex[i].account_id = evt;
			if (evt) {
				for (let ii = 0; ii < this.body.opex[i].item.length; ii++) {
					this.body.opex[i].item[ii].budget_item_id = '';
					this.body.opex[i].item[ii].fund_id = '';
					this.body.opex[i].item[ii].opex_gl = [];
					this.body.opex[i].item[ii].fund.fund = '';
					this.body.opex[i].item[ii].opex_gl_code = '';
				}
				await axiosIns
					.get(`${axiosIns.defaults.baseURL}/account/${evt}/budget-items/${this.body.fund_center_id}`)
					.then((resp) => {
						this.body.opex[i].listBudget = resp.data.data;
					});
			} else {
				this.body.opex[i].listBudget = [];
				for (let ii = 0; ii < this.body.opex[i].item.length; ii++) {
					this.body.opex[i].item[ii].budget_item_id = '';
					this.body.opex[i].item[ii].fund_id = '';
					this.body.opex[i].item[ii].opex_gl = [];
					this.body.opex[i].item[ii].fund.fund = '';
					this.body.opex[i].item[ii].opex_gl_code = '';
				}
			}
			setTimeout(() => {
				this.validateDuplicateTransactionType(i);
				this.$validator.validateAll();
			}, 200);
		},
		newBudgetItem(indx) {
			this.body.opex[indx].item.push({
				budget_item_id: '',
				opex_gl_id: '',
				opex_gl_code: '',
				fund_id: '',
				fund: [],
				budget: [],
				sum: {
					jan: 0,
					feb: 0,
					mar: 0,
					apr: 0,
					may: 0,
					jun: 0,
					jul: 0,
					aug: 0,
					sep: 0,
					oct: 0,
					nov: 0,
					dec: 0,
					total: 0,
				},
			});
		},
		newBudgetTask(i, indx) {
			this.body.opex[i].item[indx].budget.push({
				name: '',
				description: '',
				jan: 0,
				feb: 0,
				mar: 0,
				apr: 0,
				may: 0,
				jun: 0,
				jul: 0,
				aug: 0,
				sep: 0,
				oct: 0,
				nov: 0,
				dec: 0,
				total: 0,
				fund_center_id: null,
			});
		},
		newBudgetTaskCapex(i) {
			this.body.capex[i].budget.push({
				name: '',
				description: '',
				jan: 0,
				feb: 0,
				mar: 0,
				apr: 0,
				may: 0,
				jun: 0,
				jul: 0,
				aug: 0,
				sep: 0,
				oct: 0,
				nov: 0,
				dec: 0,
				total: 0,
				fund_center_id: null,
			});
		},
		async removeBudgetTaskOpex(i, indx, indxBudget) {
			const confirmed = await this.deleteConfirmation();
			if (!confirmed) {
				return;
			}
			this.body.opex[i].item[indx].budget.splice(indxBudget, 1);
			const ttlList = this.body.opex[i].item[indx].budget || [];
			const totalJan = ttlList.reduce((sum, it) => sum + BigInt(it.jan ?? 0), BigInt(0));
			const totalFeb = ttlList.reduce((sum, it) => sum + BigInt(it.feb ?? 0), BigInt(0));
			const totalMar = ttlList.reduce((sum, it) => sum + BigInt(it.mar ?? 0), BigInt(0));
			const totalApr = ttlList.reduce((sum, it) => sum + BigInt(it.apr ?? 0), BigInt(0));
			const totalMay = ttlList.reduce((sum, it) => sum + BigInt(it.may ?? 0), BigInt(0));
			const totalJun = ttlList.reduce((sum, it) => sum + BigInt(it.jun ?? 0), BigInt(0));
			const totalJul = ttlList.reduce((sum, it) => sum + BigInt(it.jul ?? 0), BigInt(0));
			const totalAug = ttlList.reduce((sum, it) => sum + BigInt(it.aug ?? 0), BigInt(0));
			const totalSep = ttlList.reduce((sum, it) => sum + BigInt(it.sep ?? 0), BigInt(0));
			const totalOct = ttlList.reduce((sum, it) => sum + BigInt(it.oct ?? 0), BigInt(0));
			const totalNov = ttlList.reduce((sum, it) => sum + BigInt(it.nov ?? 0), BigInt(0));
			const totalDec = ttlList.reduce((sum, it) => sum + BigInt(it.dec ?? 0), BigInt(0));
			const totalTotal = ttlList.reduce((sum, it) => sum + BigInt(it.total ?? 0), BigInt(0));

			this.body.opex[i].item[indx].sum.jan = parseInt(totalJan);
			this.body.opex[i].item[indx].sum.feb = parseInt(totalFeb);
			this.body.opex[i].item[indx].sum.mar = parseInt(totalMar);
			this.body.opex[i].item[indx].sum.apr = parseInt(totalApr);
			this.body.opex[i].item[indx].sum.may = parseInt(totalMay);
			this.body.opex[i].item[indx].sum.jun = parseInt(totalJun);
			this.body.opex[i].item[indx].sum.jul = parseInt(totalJul);
			this.body.opex[i].item[indx].sum.aug = parseInt(totalAug);
			this.body.opex[i].item[indx].sum.sep = parseInt(totalSep);
			this.body.opex[i].item[indx].sum.oct = parseInt(totalOct);
			this.body.opex[i].item[indx].sum.nov = parseInt(totalNov);
			this.body.opex[i].item[indx].sum.dec = parseInt(totalDec);

			this.body.opex[i].item[indx].sum.total = parseInt(totalTotal);
			this.body.opex[i].sum = this.body.opex[i].item.reduce((acc, item) => acc + Number(item.sum.total), 0);
			this.body.sum_opex = this.body.opex.reduce((acc, item) => acc + Number(item.sum), 0);

			// count sum per budget item
			//this.body.opex[i].sum = this.body.opex[i].item.reduce((acc, item) => acc + Number(item.sum.total), 0);

			// count sum opex
			//this.body.sum_opex = this.body.opex.reduce((acc, item) => acc + Number(item.sum), 0);
			this.countSumSummary();
			this.validateDuplicateTaskOpex(i, indx);
		},
		async removeBudgetTaskCapex(i, indxBudget) {
			const confirmed = await this.deleteConfirmation();
			if (!confirmed) {
				return;
			}
			this.body.capex[i].budget.splice(indxBudget, 1);
			const ttlList = this.body.capex[i].budget || [];
			const totalJan = ttlList.reduce((sum, it) => sum + BigInt(it.jan ?? 0), BigInt(0));
			const totalFeb = ttlList.reduce((sum, it) => sum + BigInt(it.feb ?? 0), BigInt(0));
			const totalMar = ttlList.reduce((sum, it) => sum + BigInt(it.mar ?? 0), BigInt(0));
			const totalApr = ttlList.reduce((sum, it) => sum + BigInt(it.apr ?? 0), BigInt(0));
			const totalMay = ttlList.reduce((sum, it) => sum + BigInt(it.may ?? 0), BigInt(0));
			const totalJun = ttlList.reduce((sum, it) => sum + BigInt(it.jun ?? 0), BigInt(0));
			const totalJul = ttlList.reduce((sum, it) => sum + BigInt(it.jul ?? 0), BigInt(0));
			const totalAug = ttlList.reduce((sum, it) => sum + BigInt(it.aug ?? 0), BigInt(0));
			const totalSep = ttlList.reduce((sum, it) => sum + BigInt(it.sep ?? 0), BigInt(0));
			const totalOct = ttlList.reduce((sum, it) => sum + BigInt(it.oct ?? 0), BigInt(0));
			const totalNov = ttlList.reduce((sum, it) => sum + BigInt(it.nov ?? 0), BigInt(0));
			const totalDec = ttlList.reduce((sum, it) => sum + BigInt(it.dec ?? 0), BigInt(0));
			const totalTotal = ttlList.reduce((sum, it) => sum + BigInt(it.total ?? 0), BigInt(0));
			this.body.capex[i].sum.jan = parseInt(totalJan);
			this.body.capex[i].sum.feb = parseInt(totalFeb);
			this.body.capex[i].sum.mar = parseInt(totalMar);
			this.body.capex[i].sum.apr = parseInt(totalApr);
			this.body.capex[i].sum.may = parseInt(totalMay);
			this.body.capex[i].sum.jun = parseInt(totalJun);
			this.body.capex[i].sum.jul = parseInt(totalJul);
			this.body.capex[i].sum.aug = parseInt(totalAug);
			this.body.capex[i].sum.sep = parseInt(totalSep);
			this.body.capex[i].sum.oct = parseInt(totalOct);
			this.body.capex[i].sum.nov = parseInt(totalNov);
			this.body.capex[i].sum.dec = parseInt(totalDec);
			this.body.capex[i].sum.total = parseInt(totalTotal);

			//this.body.sum_capex = this.body.capex.reduce((acc, item) => acc + Number(item.sum.total), 0);
			this.countSumSummary();
			this.validateDuplicateCapex(i);
		},

		removeLeadingZero(value) {
			return value && value.toString().startsWith('0') ? value.toString().replace(/^0+/, '') : value;
		},

		handleFocus(e) {
			// Menghapus angka 0 untuk setiap bulan
			list.jan = this.removeLeadingZero(list.jan);
			list.feb = this.removeLeadingZero(list.feb);
			list.mar = this.removeLeadingZero(list.mar);
			list.apr = this.removeLeadingZero(list.apr);
			list.may = this.removeLeadingZero(list.may);
			list.jun = this.removeLeadingZero(list.jun);
			list.jul = this.removeLeadingZero(list.jul);
			list.aug = this.removeLeadingZero(list.aug);
			list.sep = this.removeLeadingZero(list.sep);
			list.oct = this.removeLeadingZero(list.oct);
			list.nov = this.removeLeadingZero(list.nov);
			list.dec = this.removeLeadingZero(list.dec);
		},

		countSum(list, i, indx, indexBudget, month) {
			const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
			let total = months.reduce((acc, month) => acc + Number(list[month]), 0);
			this.body.opex[i].item[indx].budget[indexBudget].total = total ? total.toString() : 0;
			months.forEach((month) => {
				if (list[month] === '') {
					list[month] = 0;
				}
			});
			// count sum per all month
			this.body.opex[i].item[indx].sum.jan = this.body.opex[i].item[indx].budget.reduce(
				(acc, item) => acc + Number(item.jan),
				0
			);
			this.body.opex[i].item[indx].sum.feb = this.body.opex[i].item[indx].budget.reduce(
				(acc, item) => acc + Number(item.feb),
				0
			);
			this.body.opex[i].item[indx].sum.mar = this.body.opex[i].item[indx].budget.reduce(
				(acc, item) => acc + Number(item.mar),
				0
			);
			this.body.opex[i].item[indx].sum.apr = this.body.opex[i].item[indx].budget.reduce(
				(acc, item) => acc + Number(item.apr),
				0
			);
			this.body.opex[i].item[indx].sum.may = this.body.opex[i].item[indx].budget.reduce(
				(acc, item) => acc + Number(item.may),
				0
			);
			this.body.opex[i].item[indx].sum.jun = this.body.opex[i].item[indx].budget.reduce(
				(acc, item) => acc + Number(item.jun),
				0
			);
			this.body.opex[i].item[indx].sum.jul = this.body.opex[i].item[indx].budget.reduce(
				(acc, item) => acc + Number(item.jul),
				0
			);
			this.body.opex[i].item[indx].sum.aug = this.body.opex[i].item[indx].budget.reduce(
				(acc, item) => acc + Number(item.aug),
				0
			);
			this.body.opex[i].item[indx].sum.sep = this.body.opex[i].item[indx].budget.reduce(
				(acc, item) => acc + Number(item.sep),
				0
			);
			this.body.opex[i].item[indx].sum.oct = this.body.opex[i].item[indx].budget.reduce(
				(acc, item) => acc + Number(item.oct),
				0
			);
			this.body.opex[i].item[indx].sum.nov = this.body.opex[i].item[indx].budget.reduce(
				(acc, item) => acc + Number(item.nov),
				0
			);
			this.body.opex[i].item[indx].sum.dec = this.body.opex[i].item[indx].budget.reduce(
				(acc, item) => acc + Number(item.dec),
				0
			);
			this.body.opex[i].item[indx].sum.total = this.body.opex[i].item[indx].budget.reduce(
				(acc, item) => acc + Number(item.total),
				0
			);

			// count sum per budget item
			this.body.opex[i].sum = this.body.opex[i].item.reduce((acc, item) => acc + Number(item.sum.total), 0);

			// count sum opex
			this.body.sum_opex = this.body.opex.reduce((acc, item) => acc + Number(item.sum), 0);
		},

		countSumCapex(list, i, indexBudget) {
			const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
			let total = months.reduce((acc, month) => acc + Number(list[month]), 0);
			this.body.capex[i].budget[indexBudget].total = total ? total.toString() : 0;
			months.forEach((month) => {
				if (list[month] === '') {
					list[month] = 0;
				}
			});
			// count sum per all month
			this.body.capex[i].sum.jan = this.body.capex[i].budget.reduce((acc, item) => acc + Number(item.jan), 0);
			this.body.capex[i].sum.feb = this.body.capex[i].budget.reduce((acc, item) => acc + Number(item.feb), 0);
			this.body.capex[i].sum.mar = this.body.capex[i].budget.reduce((acc, item) => acc + Number(item.mar), 0);
			this.body.capex[i].sum.apr = this.body.capex[i].budget.reduce((acc, item) => acc + Number(item.apr), 0);
			this.body.capex[i].sum.may = this.body.capex[i].budget.reduce((acc, item) => acc + Number(item.may), 0);
			this.body.capex[i].sum.jun = this.body.capex[i].budget.reduce((acc, item) => acc + Number(item.jun), 0);
			this.body.capex[i].sum.jul = this.body.capex[i].budget.reduce((acc, item) => acc + Number(item.jul), 0);
			this.body.capex[i].sum.aug = this.body.capex[i].budget.reduce((acc, item) => acc + Number(item.aug), 0);
			this.body.capex[i].sum.sep = this.body.capex[i].budget.reduce((acc, item) => acc + Number(item.sep), 0);
			this.body.capex[i].sum.oct = this.body.capex[i].budget.reduce((acc, item) => acc + Number(item.oct), 0);
			this.body.capex[i].sum.nov = this.body.capex[i].budget.reduce((acc, item) => acc + Number(item.nov), 0);
			this.body.capex[i].sum.dec = this.body.capex[i].budget.reduce((acc, item) => acc + Number(item.dec), 0);
			this.body.capex[i].sum.total = this.body.capex[i].budget.reduce((acc, item) => acc + Number(item.total), 0);

			// count sum capex
			this.body.sum_capex = this.body.capex.reduce((acc, item) => acc + Number(item.sum.total), 0);
		},
		countSumSummary() {
			// count sum opex
			for (let x = 0; x < this.body.opex.length; x++) {
				for (let y = 0; y < this.body.opex[x].item.length; y++) {
					this.body.opex[x].item[y].sum.total = this.body.opex[x].item[y].budget.reduce(
						(acc, item) => acc + Number(item.total),
						0
					);
				}
				this.body.opex[x].sum = this.body.opex[x].item.reduce((acc, item) => acc + Number(item.sum.total), 0);
			}
			this.body.sum_opex = this.body.opex.reduce((acc, item) => acc + Number(item.sum), 0);

			// count sum capex
			for (let x = 0; x < this.body.capex.length; x++) {
				for (let y = 0; y < this.body.capex[x].budget.length; y++) {
					this.body.capex[x].sum.total = this.body.capex[x].budget.reduce((acc, item) => acc + Number(item.total), 0);
				}
			}
			this.body.sum_capex = this.body.capex.reduce((acc, item) => acc + Number(item.sum.total), 0);
		},

		convertNumber(dat) {
			return dat ? dat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') : '0';
		},

		async searchGL(id, i, index) {
			this.listFund[i] = [];
			this.body.opex[i].item[index].fund_id = '';
			this.body.opex[i].item[index].opex_gl = [];
			this.body.opex[i].item[index].fund.fund = '';
			this.body.opex[i].item[index].opex_gl_code = '';
			this.body.opex[i].item[index].opex_gl_id = '';
			if (!id) {
				const confirmed = await this.deleteConfirmation();
				if (!confirmed) {
					return;
				}
			}
			this.body.opex[i].item[index].budget_item_id = id;
			if (id) {
				/*await axiosIns.get(`${axiosIns.defaults.baseURL}/opex-gl/${id}`).then(async (resp) => {
					let glCode = resp.data.data.gl_code;
					let glId = resp.data.data.id;
					this.body.opex[i].item[index].opex_gl_id = glId;
					await this.getListFund(resp.data.data.budget_item_id, i, index);
				});*/
				let fundData = await Promise.all(this.body.opex[i].listBudget);
				let fundSelected = fundData.find((item) => parseInt(item.id) === parseInt(id));
				if (fundSelected) {
					this.body.opex[i].item[index].fund_id = fundSelected.fund[0]?.id || null;
					this.body.opex[i].item[index].opex_gl = fundSelected.opex_gl[0] || [];
					this.body.opex[i].item[index].fund.fund = fundSelected.fund[0]?.fund || '';
					this.body.opex[i].item[index].opex_gl_code = fundSelected.opex_gl[0]?.gl_code || '';
					this.body.opex[i].item[index].opex_gl_id = fundSelected.opex_gl[0]?.id || '';
				}
			}
			/*
      else {
				this.listFund[i] = [];
				this.body.opex[i].item[index].fund_id = '';
				this.body.opex[i].item[index].opex_gl = [];
				this.body.opex[i].item[index].fund.fund = '';
				this.body.opex[i].item[index].opex_gl_code = '';
			}
      */
			setTimeout(() => {
				this.validateDuplicateBudgetItemOpex(i);
				this.$validator.validateAll();
			}, 200);
		},
		searchGLByFund(id, i, index) {
			if (id) {
				const filtered = this.listFund.filter((item) => item.value === id);
				this.body.opex[i].item[index].opex_gl_code = filtered[0]?.gl_code;
			}
		},
		searchGLByFundCapex(id, i) {
			if (id) {
				const filtered = this.listFundCapex.filter((item) => item.value === id);
				this.body.capex[i].capex_gl_id = filtered[0]?.gl_id;
				this.body.capex[i].capex_gl_code = filtered[0]?.gl_code;
			}
		},

		async searchGLCapex(id, i) {
			if (!id) {
				const confirmed = await this.deleteConfirmation();
				if (!confirmed) {
					return;
				}
			}

			if (id) {
				const glSelected = this.listCapex.find((item) => parseInt(item.id) === parseInt(id));
				if (glSelected) {
					this.listFundCapex = [
						{
							label: glSelected.fund,
							value: glSelected.fund_id,
							gl_code: glSelected.gl_code,
							gl_id: glSelected.id,
						},
					];
					this.body.capex[i].fund_id = glSelected?.fund_id;
					this.body.capex[i].fund.fund = glSelected?.fund;
					this.body.capex[i].capex_gl_id = glSelected?.id;
					this.body.capex[i].capex_gl_code = glSelected?.gl_code;
					this.body.capex[i].account_id = glSelected?.account_id;
				} else {
					this.body.capex[i].fund_id = '';
					this.body.capex[i].fund.fund = '';
					this.body.capex[i].capex_gl_id = '';
					this.body.capex[i].capex_gl_code = '';
					this.body.capex[i].account_id = '';
				}
				// await axiosIns.get(`${axiosIns.defaults.baseURL}/capex-gl/${id}/${this.body.fund_center_id}`).then(async (resp) => {
				// 	if (resp?.data.data) {
				// 		this.listFundCapex = resp.data.data.map((items) => ({
				// 			label: items.fund.fund,
				// 			value: items.fund.id,
				// 			gl_code: items.gl_code,
				// 			gl_id: items.id,
				// 		}));
				// 		this.body.capex[i].fund_id = resp?.data.data[0]?.fund.id;
				// 		this.body.capex[i].fund.fund = resp?.data.data[0].fund.fund;
				// 		this.body.capex[i].capex_gl_id = resp?.data.data[0]?.id;
				// 		this.body.capex[i].capex_gl_code = resp?.data.data[0]?.gl_code;
				// 	} else {
				// 		this.body.capex[i].fund_id = '';
				// 		this.body.capex[i].fund.fund = '';
				// 		this.body.capex[i].capex_gl_id = '';
				// 		this.body.capex[i].capex_gl_code = '';
				// 	}
				// });
			} else {
				this.listFundCapex = [];
				this.body.capex[i].fund_id = '';
				this.body.capex[i].fund.fund = '';
				this.body.capex[i].capex_gl_id = '';
				this.body.capex[i].capex_gl_code = '';
				this.body.capex[i].account_id = '';
			}
			setTimeout(() => {
				this.validateDuplicateBudgetItemCapex(i);
				this.$validator.validateAll();
			}, 200);
		},

		momentFormat(e) {
			console.log(e);
			// return
		},

		submitAll() {
			this.isLoading = true;
			const bodOpex = this.body?.opex;
			const bodCapex = this.body?.capex;

			if (
				this.duplicateErrorIndexesTransactionType.length > 0 ||
				this.duplicateErrorIndexesBudgetItemOpex.length > 0 ||
				this.duplicateErrorIndexes.length > 0
			) {
				this.activeTab = 0;
				setTimeout(() => {
					if (this.duplicateErrorIndexesTransactionType.length > 0) {
						this.activeTab = 0;
						const transactionType = this.duplicateErrorIndexesTransactionType[0];
						const el = document.getElementsByName(transactionType)[0];
						if (el) {
							const input = el.querySelector('input') || el;
							input.focus();
						}
					}
					if (this.duplicateErrorIndexesBudgetItemOpex.length > 0) {
						this.activeTab = 0;
						const budgetItemsOpex = this.duplicateErrorIndexesBudgetItemOpex[0];
						const el = document.getElementsByName(budgetItemsOpex)[0];
						if (el) {
							const input = el.querySelector('input') || el;
							input.focus();
						}
					}
					if (this.duplicateErrorIndexes.length > 0) {
						const taskOpex = this.duplicateErrorIndexes[0];
						document.getElementsByName(taskOpex)[0].focus();
					}
				}, 200);
			}
			/* set focus capex */
			if (this.duplicateErrorIndexesBudgetItemCapex.length > 0 || this.duplicateErrorIndexesCapex.length > 0) {
				this.activeTab = 1;
				setTimeout(() => {
					if (this.duplicateErrorIndexesBudgetItemCapex.length > 0) {
						const itemsCapex = this.duplicateErrorIndexesBudgetItemCapex[0];
						const el = document.getElementsByName(itemsCapex)[0];
						if (el) {
							const input = el.querySelector('input') || el;
							input.focus();
						}
					}
					if (this.duplicateErrorIndexesCapex.length > 0) {
						const taskCapex = this.duplicateErrorIndexesCapex[0];
						document.getElementsByName(taskCapex)[0].focus();
					}
				}, 500); // 2000 ms = 2 seconds
			}
			bodOpex.forEach((type, index) => {
				if (!type?.account_id) {
					let transactionType = index + '_transaction_type_opex';
					const el = document.getElementsByName(transactionType)[0];
					if (el) {
						this.activeTab = 0;
						setTimeout(() => {
							const input = el.querySelector('input') || el;
							input.focus();
							return;
						}, 500);
					}
				} else {
					type?.item?.forEach((itm, indexItm) => {
						if (!itm?.budget_item_id) {
							let budgetItemsOpex = index + '_' + indexItm + '_budget_item_opex';
							const el = document.getElementsByName(budgetItemsOpex)[0];
							if (el) {
								this.activeTab = 0;
								setTimeout(() => {
									const input = el.querySelector('input') || el;
									input.focus();
									return;
								}, 500);
							}
						} else {
							itm?.budget?.forEach((tsk, indexItmTsk) => {
								if (!tsk?.name) {
									let taskOpex = index + '_' + indexItm + '_' + indexItmTsk + '_budget_task_opex';
									const el = document.getElementsByName(taskOpex)[0];
									if (el) {
										this.activeTab = 0;
										setTimeout(() => {
											const input = el.querySelector('input') || el;
											input.focus();
											return;
										}, 500);
									}
								}
							});
						}
					});
				}
			});

			bodCapex.forEach((type, index) => {
				if (!type?.account_id) {
					let transactionType = index + '_budget_item_capex';
					const el = document.getElementsByName(transactionType)[0];
					if (el) {
						this.activeTab = 1;
						setTimeout(() => {
							const input = el.querySelector('input') || el;
							input.focus();
							return;
						}, 500);
					}
				} else {
					type?.budget?.forEach((tsk, indexItmTsk) => {
						if (!tsk?.name) {
							let taskCapex = index + '_' + indexItmTsk + '_budget_task_capex';
							const el = document.getElementsByName(taskCapex)[0];
							if (el) {
								this.activeTab = 1;
								setTimeout(() => {
									const input = el.querySelector('input') || el;
									input.focus();
									return;
								}, 500);
							}
						}
					});
				}
			});
			this.$validator.validateAll().then((success) => {
				if (
					success &&
					this.duplicateErrorIndexesTransactionType.length === 0 &&
					this.duplicateErrorIndexesBudgetItemOpex.length === 0 &&
					this.duplicateErrorIndexesBudgetItemCapex.length === 0 &&
					this.duplicateErrorIndexes.length === 0 &&
					this.duplicateErrorIndexesCapex.length === 0
				) {
					this.$swal({
						title: 'Submit Data',
						// text: "You won't be able to revert this!",
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#00D97E',
						cancelButtonColor: '#E63757',
						confirmButtonText: 'Submit',
						cancelButtonText: 'Cancel',
					}).then((result) => {
						if (result.isConfirmed) {
							let bod = this.body;
							console.log('isi body: ', bod);
							// delete bod.fund_center
							// delete bod.sum_capex
							// delete bod.sum_opex
							// for (let i = 0; i < bod.opex.length; i++) {
							//   delete bod.opex[i].listBudget
							//   delete bod.opex[i].sum
							//   for (let d = 0; d < bod.opex[i].item.length; d++) {
							//     delete bod.opex[i].item[d].opex_gl_code
							//     delete bod.opex[i].item[d].sum
							//   }
							// }
							// for (let y = 0; y < bod.capex.length; y++) {
							//   delete bod.capex[y].capex_gl_code
							//   delete bod.capex[y].sum
							// }
							this.$store
								.dispatch('budgetPlan/SUBMIT_BUDGET_PLAN', bod)
								.then((resp) => {
									this.isLoading = false;
									this.$swal('Saved!', 'Your data has been submit', 'success');
									this.$router.push({
										name: 'budget_plan',
									});
								})
								.catch((resp) => {
									this.isLoading = false;
									this.$swal('Error', resp?.response?.data?.error, 'error').then(() => {
										// window.location.reload()
									});
								});
						}
					});
				}
			});
			/* remark dulu */
			/*this.$validator.validateAll().then(success => {
          this.$swal({
          title: "Submit Data",
          // text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#00D97E",
          cancelButtonColor: "#E63757",
          confirmButtonText: "Submit",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            let bod = this.body
            console.log("isi body: ", bod);
            // delete bod.fund_center
            // delete bod.sum_capex
            // delete bod.sum_opex
            // for (let i = 0; i < bod.opex.length; i++) {
            //   delete bod.opex[i].listBudget
            //   delete bod.opex[i].sum
            //   for (let d = 0; d < bod.opex[i].item.length; d++) {
            //     delete bod.opex[i].item[d].opex_gl_code
            //     delete bod.opex[i].item[d].sum
            //   }
            // }
            // for (let y = 0; y < bod.capex.length; y++) {
            //   delete bod.capex[y].capex_gl_code
            //   delete bod.capex[y].sum
            // }
            this.$store
              .dispatch("budgetPlan/SUBMIT_BUDGET_PLAN", bod)
              .then((resp) => {
                this.$swal("Saved!", "Your data has been submit", "success");
                this.$router.push({
                  name: "budget_plan"
                });
              })
              .catch((resp) => {
                this.$swal("Error", resp?.response?.data?.error, "error").then(() => {
                  // window.location.reload()
                });
              });
          }
        });
        })*/

			// },
			// this.$store.dispatch('budgetPlan/SUBMIT_BUDGET_PLAN')
		},

		historyBack() {
			this.$router.push({
				name: 'budget_plan',
			});
		},

		toNumber(value) {
			if (value === '' || value === undefined) return 0;
			if (value.split('.')[0] === '' || value.split('.')[0] === undefined) return 0;
			let cleanedValue = value.split('.')[0].replace(/\D/g, '');
			return parseFloat(cleanedValue) || 0;
		},

		handlePasteOpex(e) {
			e.preventDefault();
			if (!this.body.fund_center_id) return;

			const parseTransactionType = (column) => {
				const splitColumn = column.split('-');
				if (splitColumn.length > 1) {
					return splitColumn[0].trim().toString();
				}
				return null;
			};

			const addTransactionType = async (transactionId, index) => {
				const ttAccount = this.listTT?.data?.find((item) => item.code === transactionId);
				if (!ttAccount) {
					return;
				}
				this.addBudget('opex');
				this.body.opex[index].account_id = ttAccount?.id;
				await this.selectTransaction(ttAccount?.id, index);
			};

			const findBudgetItem = (budgetItemCode, index) => {
				// return this.body.opex[index]?.listBudget?.find((item) => item.item === budgetItemCode);
				return this.body.opex[index]?.listBudget?.find((item) => item?.opex_gl?.[0]?.gl_code === budgetItemCode);
			};

			const addBudgetItem = async (itemId, index, itemIndex) => {
				this.body.opex[index].item[itemIndex].budget_item_id = itemId;
				await this.searchGL(itemId, index, itemIndex);
			};

			const addBudgetTask = async (item, index, itemIndex) => {
				const monthList = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
				this.newBudgetTask(index, itemIndex);
				const taskIndex = this.body.opex[index].item[itemIndex].budget.length - 1;
				const budgetTask = this.body.opex[index].item[itemIndex].budget[taskIndex];

				budgetTask.name = item.name;
				budgetTask.description = item.description;

				for (const month of monthList) {
					budgetTask[month] = item[month] || 0;
					await this.countSum(item, index, itemIndex, taskIndex, month);
				}
				await this.validateDuplicateTaskOpex(index, itemIndex);
			};

			let text = e.clipboardData.getData('text/plain');
			text = this.sanitizeStringNewLine(text);

			this.$swal({
				title: 'Are you sure?',
				text: 'All the data will be replaced by the pasted data',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#00D97E',
				cancelButtonColor: '#E63757',
				confirmButtonText: 'Yes, paste it!',
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.loadingPaste = true;
					const errorOpex = [];
					try {
						this.body.opex = [];
						const lines = text.split('\n');
						let index = -1;
						let itemIndex = -1;
						let budgetItemValid = false;
						for (const line of lines) {
							const columns = line.split('\t');
							const firstColumn = columns[0]?.trim();
							const secondColumn = columns[1]?.trim();

							if (firstColumn) {
								const transactionId = parseTransactionType(firstColumn);
								// exit loop if capex
								if (firstColumn && firstColumn.toLowerCase() === 'capex') break;

								if (transactionId) {
									index++;
									itemIndex = -1;
									await addTransactionType(transactionId, index);
									continue;
								}
								if (parseInt(firstColumn)) {
									const budgetItem = findBudgetItem(firstColumn, index);
									if (budgetItem) {
										budgetItemValid = true;
										this.newBudgetItem(index);
										itemIndex++;
										await addBudgetItem(budgetItem.id, index, itemIndex);
										continue;
									}
									errorOpex.push(`Budget item not found :${firstColumn} - ${columns[2]}`);
									budgetItemValid = false;
									continue;
								}
							}
							// if (secondColumn) {
							// 	const budgetItem = findBudgetItem(secondColumn, index);
							// 	if (budgetItem) {
							// 		budgetItemValid = true;
							// 		this.newBudgetItem(index);
							// 		itemIndex++;
							// 		await addBudgetItem(budgetItem.id, index, itemIndex);
							// 		continue;
							// 	}
							// 	errorOpex.push(`Budget item not found :${secondColumn} - ${columns[2]}`);
							// 	budgetItemValid = false;
							// 	continue;
							// }
							if (budgetItemValid && columns[2]?.trim() !== '' && columns[2]?.trim() !== undefined) {
								const item = {
									name: columns[2],
									description: columns[3],
									jan: this.toNumber(columns[5]) || 0,
									feb: this.toNumber(columns[6]) || 0,
									mar: this.toNumber(columns[7]) || 0,
									apr: this.toNumber(columns[8]) || 0,
									may: this.toNumber(columns[9]) || 0,
									jun: this.toNumber(columns[10]) || 0,
									jul: this.toNumber(columns[11]) || 0,
									aug: this.toNumber(columns[12]) || 0,
									sep: this.toNumber(columns[13]) || 0,
									oct: this.toNumber(columns[14]) || 0,
									nov: this.toNumber(columns[15]) || 0,
									dec: this.toNumber(columns[16]) || 0,
								};
								await addBudgetTask(item, index, itemIndex);
							}
						}
						this.loadingPaste = false;
					} catch (error) {
						console.error(error);
						errorOpex.push(error.message);
						this.$swal({
							title: 'Error',
							text: 'Invalid data format',
							icon: 'error',
							confirmButtonColor: '#00D97E',
						});
						this.loadingPaste = false;
						this.body.opex = [];
					}
					if (this.body.opex.length < 1) {
						this.$swal({
							title: 'Error',
							text: 'Invalid data format',
							icon: 'error',
							confirmButtonColor: '#00D97E',
						});
						this.loadingPaste = false;
					}
					console.log('errorOpex', errorOpex);
					this.countSumSummary();
				}
			});
		},
		handlePasteOpexImport() {
			if (!this.body.fund_center_id) return;
			if (
				this.body_create?.title &&
				this.body_create.year &&
				(this.body_create?.opex?.length > 0 ||
					this.body_create?.capex?.length > 0 ||
					this.body_create?.opex_error?.length > 0 ||
					this.body_create?.capex_error?.length > 0)
			) {
				for (let i in this.body?.opex) {
					this.validateDuplicateTransactionType(i);
					for (let ii in this.body?.opex[i].item) {
						this.validateDuplicateBudgetItemOpex(i);
						this.validateDuplicateTaskOpex(i, ii);
					}
				}
				for (let i in this.body?.capex) {
					this.validateDuplicateBudgetItemCapex(i);
					this.validateDuplicateCapex(i);
				}

				this.$validator.validateAll();
			}
		},
		setSelectedBudget(i, ii, id) {
			this.body.opex[i].item[ii].budget_item_id = id;
			//this.listBudget[index].budget_item_id = id
		},

		handlePasteCapex(e) {
			e.preventDefault();
			if (!this.body.fund_center_id) return;
			const errorCapex = [];
			const plainListCapex = this.listCapex.map((item) => JSON.parse(JSON.stringify(item)));
			console.log('plainListCapex', plainListCapex);

			const findBudgetItem = (glCode, budgetItemCode) => {
				// return this.listCapex.find((item) => item.gl_code === glCode && item.account_id === budgetItemCode);
				return this.listCapex.find((item) => item.gl_code === glCode && item.account_code === budgetItemCode);
			};

			const addBudgetItem = async (itemId, index) => {
				this.body.capex[index].account_id = itemId;
				await this.searchGLCapex(itemId, index);
			};

			const addBudgetTask = async (item, index) => {
				const monthList = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
				this.newBudgetTaskCapex(index);
				const taskIndex = this.body.capex[index].budget.length - 1;
				const budgetTask = this.body.capex[index].budget[taskIndex];

				budgetTask.name = item.name;
				budgetTask.description = item.description;

				for (const month of monthList) {
					budgetTask[month] = item[month] || 0;
					await this.countSumCapex(item, index, taskIndex, month);
				}
				this.validateDuplicateCapex(index);
			};

			let text = e.clipboardData.getData('text/plain');
			text = this.sanitizeStringNewLine(text);

			this.$swal({
				title: 'Are you sure?',
				text: 'All the data will be replaced by the pasted data',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#00D97E',
				cancelButtonColor: '#E63757',
				confirmButtonText: 'Yes, paste it!',
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.loadingPaste = true;
					const errorCapex = [];
					try {
						this.body.capex = [];
						const lines = text.split('\n');
						let index = -1;
						let budgetItemValid = false;
						for (const line of lines) {
							const columns = line.split('\t');
							const firstColumn = columns[0]?.trim();
							const secondColumn = columns[1]?.trim();
							if (parseInt(firstColumn)) {
								const budgetItem = findBudgetItem(firstColumn, secondColumn);
								if (budgetItem) {
									index++;
									await this.addBudget('capex');
									await addBudgetItem(budgetItem.id, index);
									budgetItemValid = true;
									continue;
								}
								errorCapex.push(`Budget item not found: ${firstColumn} - ${secondColumn} - ${columns[2]}`);
								budgetItemValid = false;
								continue;
							}
							if (budgetItemValid && columns[2]?.trim() !== '' && columns[2]?.trim() !== undefined) {
								const item = {
									name: columns[2],
									description: columns[3],
									jan: this.toNumber(columns[5]) || 0,
									feb: this.toNumber(columns[6]) || 0,
									mar: this.toNumber(columns[7]) || 0,
									apr: this.toNumber(columns[8]) || 0,
									may: this.toNumber(columns[9]) || 0,
									jun: this.toNumber(columns[10]) || 0,
									jul: this.toNumber(columns[11]) || 0,
									aug: this.toNumber(columns[12]) || 0,
									sep: this.toNumber(columns[13]) || 0,
									oct: this.toNumber(columns[14]) || 0,
									nov: this.toNumber(columns[15]) || 0,
									dec: this.toNumber(columns[16]) || 0,
								};
								await addBudgetTask(item, index);
							}
						}
						this.loadingPaste = false;
					} catch (error) {
						console.log(error);
						this.$swal({
							title: 'Error',
							text: 'Invalid data format',
							icon: 'error',
							confirmButtonColor: '#00D97E',
						});
						this.loadingPaste = false;
					}
					if (this.body.capex.length < 1) {
						this.$swal({
							title: 'Error',
							text: 'Invalid data format',
							icon: 'error',
							confirmButtonColor: '#00D97E',
						});
						this.loadingPaste = false;
						this.body.capex = [];
					}
					console.log('errorCapex', errorCapex);
					this.countSumSummary();
				}
			});
		},
		handlePasteTaskOpex(e, index, itemIndex) {
			e.preventDefault();
			if (!this.body.opex[index].item[itemIndex].budget_item_id) return;

			const addBudgetTask = async (item, index, itemIndex) => {
				const monthList = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
				this.newBudgetTask(index, itemIndex);
				const taskIndex = this.body.opex[index].item[itemIndex].budget.length - 1;
				const budgetTask = this.body.opex[index].item[itemIndex].budget[taskIndex];

				budgetTask.name = item.name;
				budgetTask.description = item.description;

				for (const month of monthList) {
					budgetTask[month] = item[month] || 0;
					await this.countSum(item, index, itemIndex, taskIndex, month);
				}
				await this.validateDuplicateTaskOpex(index, itemIndex);
			};

			let text = e.clipboardData.getData('text/plain');
			text = this.sanitizeStringNewLine(text);

			this.$swal({
				title: 'Are you sure?',
				text: 'All the data will be replaced by the pasted data',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#00D97E',
				cancelButtonColor: '#E63757',
				confirmButtonText: 'Yes, paste it!',
			}).then(async (result) => {
				if (result.isConfirmed) {
					const lines = text.split('\n');
					this.body.opex[index].item[itemIndex].budget = [];
					try {
						for (const line of lines) {
							const columns = line.split('\t');
							if (columns[0]?.trim() !== '' && columns[0]?.trim() !== undefined) {
								const item = {
									name: columns[0],
									description: columns[1],
									jan: this.toNumber(columns[3]) || 0,
									feb: this.toNumber(columns[4]) || 0,
									mar: this.toNumber(columns[5]) || 0,
									apr: this.toNumber(columns[6]) || 0,
									may: this.toNumber(columns[7]) || 0,
									jun: this.toNumber(columns[8]) || 0,
									jul: this.toNumber(columns[9]) || 0,
									aug: this.toNumber(columns[10]) || 0,
									sep: this.toNumber(columns[11]) || 0,
									oct: this.toNumber(columns[12]) || 0,
									nov: this.toNumber(columns[13]) || 0,
									dec: this.toNumber(columns[14]) || 0,
								};
								await addBudgetTask(item, index, itemIndex);
							}
						}
					} catch (error) {
						console.log(error);
						this.$swal({
							title: 'Error',
							text: 'Invalid data format',
							icon: 'error',
							confirmButtonColor: '#00D97E',
						});
					}
					if (this.body.opex[index].item[itemIndex].budget.length < 1) {
						this.$swal({
							title: 'Error',
							text: 'Invalid data format',
							icon: 'error',
							confirmButtonColor: '#00D97E',
						});
					}
					this.countSumSummary();
				}
			});
		},
		handlePasteTaskCapex(e, index) {
			e.preventDefault();
			if (!this.body.capex[index].account_id) return;

			const addBudgetTask = async (item, index) => {
				const monthList = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
				this.newBudgetTaskCapex(index);
				const taskIndex = this.body.capex[index].budget.length - 1;
				const budgetTask = this.body.capex[index].budget[taskIndex];

				budgetTask.name = item.name;
				budgetTask.description = item.description;

				for (const month of monthList) {
					budgetTask[month] = item[month] || 0;
					await this.countSumCapex(item, index, taskIndex, month);
				}
				this.validateDuplicateCapex(index);
			};

			let text = e.clipboardData.getData('text/plain');
			text = this.sanitizeStringNewLine(text);

			this.$swal({
				title: 'Are you sure?',
				text: 'All the data will be replaced by the pasted data',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#00D97E',
				cancelButtonColor: '#E63757',
				confirmButtonText: 'Yes, paste it!',
			}).then(async (result) => {
				if (result.isConfirmed) {
					const lines = text.split('\n');
					this.body.capex[index].budget = [];
					try {
						for (const line of lines) {
							const columns = line.split('\t');
							if (columns[0]?.trim() !== '' && columns[0]?.trim() !== undefined) {
								const item = {
									name: columns[0],
									description: columns[1],
									jan: this.toNumber(columns[3]) || 0,
									feb: this.toNumber(columns[4]) || 0,
									mar: this.toNumber(columns[5]) || 0,
									apr: this.toNumber(columns[6]) || 0,
									may: this.toNumber(columns[7]) || 0,
									jun: this.toNumber(columns[8]) || 0,
									jul: this.toNumber(columns[9]) || 0,
									aug: this.toNumber(columns[10]) || 0,
									sep: this.toNumber(columns[11]) || 0,
									oct: this.toNumber(columns[12]) || 0,
									nov: this.toNumber(columns[13]) || 0,
									dec: this.toNumber(columns[14]) || 0,
								};
								await addBudgetTask(item, index);
							}
						}
					} catch (error) {
						console.log(error);
						this.$swal({
							title: 'Error',
							text: 'Invalid data format',
							icon: 'error',
							confirmButtonColor: '#00D97E',
						});
					}
					if (this.body.capex[index].budget.length < 1) {
						this.$swal({
							title: 'Error',
							text: 'Invalid data format',
							icon: 'error',
							confirmButtonColor: '#00D97E',
						});
					}
					this.countSumSummary();
				}
			});
		},

		async setSelectedDepartment() {
			const selectedFundCenter = this.$store.getters['budgetPlan/selectedFundCenter'];
			if (!selectedFundCenter) {
				if (!this.activePlan) await this.$store.dispatch('budgetPlan/GET_ACTIVE_PLAN');
				const selectedDepartment = this.listDepartement?.find(
					(e) => e.row?.department_code === this.activePlan?.fund_center?.department_code
				);
				this.body.fund_center_id = selectedDepartment?.value;
			} else {
				this.body.fund_center_id = selectedFundCenter;
			}

			await this.selectFundCenter(this.body.fund_center_id);
		},

		async deleteConfirmation() {
			const response = await this.$swal({
				title: 'Are you sure?',
				text: 'You will not be able to recover this data!',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#00D97E',
				cancelButtonColor: '#E63757',
				confirmButtonText: 'Yes, delete it!',
			});

			return response.isConfirmed;
		},

		sanitizeStringNewLine(text) {
			//search quoted string
			return text.replace(/"[^"]*"/g, (match) => {
				//remove quotes
				const contentWithoutQuotes = match.slice(1, -1);
				//replace \n with space so it will not threated as new line
				return contentWithoutQuotes.replace(/\n/g, ' ').replace(/\r/g, '');
			});
		},
	},
};
</script>

<style>
.popover {
	min-width: 300px !important;
}
.popover-body {
	color: #4e4c4c !important;
}
</style>
